module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-money',\n    title: 'My compensation',\n    description: 'Manage how company income reaches your wallet.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/4-owner-compensation/owner-compensation.section-header.html
// module id = 4100
// module chunks = 86